import { isNativeApp, isNativeIOS } from "./runtime";

let configurationPromise = null;

export async function configureNativeKeyboard() {
  if (!isNativeIOS()) return false;
  if (configurationPromise) return configurationPromise;

  configurationPromise = import("@capacitor/keyboard")
    .then(({ Keyboard }) =>
      Keyboard.setAccessoryBarVisible({ isVisible: false })
    )
    .then(() => true)
    .catch((error) => {
      configurationPromise = null;
      throw error;
    });

  return configurationPromise;
}

export async function dismissNativeKeyboard() {
  if (!isNativeApp()) return false;

  try {
    const { Keyboard } = await import("@capacitor/keyboard");
    await Keyboard.hide();
    return true;
  } catch {
    return false;
  }
}
